import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[noWhitespace]',
})
export class NoWhitespaceDirective {
  @HostListener('keypress', ['$event'])
  validateInput(event: KeyboardEvent) {
    // Previne a entrada de espaços em branco (espaço, tab, etc.)
    if (event.key === ' ' || event.key === 'Tab' || /\s/.test(event.key)) {
      event.preventDefault();
      return;
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    // Previne colar conteúdo com espaços
    const clipboardData = event.clipboardData;
    if (clipboardData) {
      const pastedText = clipboardData.getData('text');
      if (pastedText.includes(' ') || /\s/.test(pastedText)) {
        event.preventDefault();
      }
    }
  }
}
